/* Caseta „Completează-ți rutina Mayie” (snippets/mayie-chrome-cart-upsell.liquid): adăugarea în coș și săgețile. */
(() => {
  if (window.mayieCartUpsell) return;
  window.mayieCartUpsell = true;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const targetFor = (box) => {
    if (box && box.dataset.context === 'page') {
      const items = document.querySelector('cart-items');
      if (items && typeof items.getSectionsToRender === 'function') {
        return { page: true, host: items, sections: items.getSectionsToRender() };
      }
    }
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      return { page: false, host: drawer, sections: drawer.getSectionsToRender() };
    }
    return null;
  };

  const showError = (box, message) => {
    const el = box && box.querySelector('.mayie-cart-upsell__error');
    if (!el) return;
    el.textContent = message || '';
    el.hidden = !message;
  };

  const focusLine = (drawer, variantId) => {
    const input = drawer.querySelector(`[data-quantity-variant-id="${variantId}"]`);
    const name = (input && input.closest('.cart-item')?.querySelector('.cart-item__name')) || drawer.querySelector('.cart-item__name');
    const inner = drawer.querySelector('.drawer__inner');
    if (name && inner && typeof trapFocus === 'function') trapFocus(inner, name);
  };

  const add = async (button) => {
    if (button.getAttribute('aria-disabled') === 'true') return;
    const box = button.closest('[data-mayie-upsell]');
    const target = targetFor(box);
    const variantId = button.dataset.variantId;
    const body = new FormData();
    body.append('id', variantId);
    body.append('quantity', '1');
    if (target) {
      body.append('sections', target.sections.map((s) => (target.page ? s.section : s.id)).join(','));
      body.append('sections_url', window.location.pathname);
    }

    button.setAttribute('aria-disabled', 'true');
    button.classList.add('loading');
    button.querySelector('.loading__spinner')?.classList.remove('hidden');
    showError(box, '');

    try {
      const response = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body,
      });
      const state = await response.json();
      if (state.status) {
        showError(box, state.description || state.message);
        return;
      }
      if (!target) {
        window.location = window.routes.cart_url;
        return;
      }
      if (target.page) {
        target.sections.forEach((s) => {
          const host = document.getElementById(s.id);
          const html = state.sections && state.sections[s.section];
          if (!host || html == null) return;
          const el = host.querySelector(s.selector) || host;
          el.innerHTML = target.host.getSectionInnerHTML(html, s.selector);
        });
        // Secțiunile paginii sunt deja la zi: aceeași sursă ca Dawn după o schimbare de cantitate, ca nimeni să nu le mai ceară.
        if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: state, variantId });
      } else {
        if (typeof publish === 'function') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mayie-cart-upsell', productVariantId: variantId, cartData: state });
        }
        target.host.renderContents(state);
        setTimeout(() => focusLine(target.host, variantId), 120);
      }
    } catch (error) {
      showError(box, window.cartStrings ? window.cartStrings.error : '');
    } finally {
      if (button.isConnected) {
        button.removeAttribute('aria-disabled');
        button.classList.remove('loading');
        button.querySelector('.loading__spinner')?.classList.add('hidden');
      }
    }
  };

  const slide = (button) => {
    const track = button.closest('.mayie-cart-upsell__rail')?.querySelector('.mayie-cart-upsell__track');
    if (!track) return;
    const item = track.querySelector('.mayie-cart-upsell__item');
    const step = item ? item.getBoundingClientRect().width + 8 : track.clientWidth;
    track.scrollBy({
      left: button.dataset.mayieUpsellNav === 'next' ? step : -step,
      behavior: reduceMotion.matches ? 'auto' : 'smooth',
    });
  };

  document.addEventListener('click', (event) => {
    const addButton = event.target.closest('[data-mayie-upsell-add]');
    if (addButton) {
      event.preventDefault();
      add(addButton);
      return;
    }
    const nav = event.target.closest('[data-mayie-upsell-nav]');
    if (nav) {
      event.preventDefault();
      slide(nav);
    }
  });
})();
